<template>
  <CCol xl="6" class="mb-3" v-if="activeGalleries.length > 0 && hasPerm('gallery.browse_photo')">
    <div class="overview-widget overview-galleries" data-v-step="0">
      <div class="d-flex overview-galleries__cont">
        <div>
          <div class="overview-galleries__icon">
            <CIcon name="cipPhotographer" size="custom" :height="28"/>
            <div class="overview-galleries__sub-icon">
              <CIcon name="cipUpload2" size="custom" :height="12"/>
            </div>
          </div>
        </div>

        <div class="w-100">
          <div class="overview-widget__head">
            <div class="d-flex align-items-center">
              <h5 class="m-0" v-translate>Upload and deliver photos</h5>
              <PTooltip class="ml-2" :content="tooltip.content()" :color="tooltip.color"
                        :placement="tooltip.placement"/>
            </div>
          </div>
          <div class="overview-widget__body">
            <div class="overview-galleries__text mb-4">
              <template v-if="permissions.canSoftDelete">
                <translate translate-context="event_wizard.overview">
                  Uploaded photos will remain in the album permanently, but you can manage their visibility for participants with the hide photo function.
                </translate>
              </template>
              <template v-else>
                <translate translate-context="event_wizard.overview">
                  Choose a gallery below and upload your photos directly to the Media section.
                </translate>
              </template>
            </div>
            <label class="small" v-translate translate-context="event_wizard.overview">Choose a gallery</label>
            <GalleriesDropDown :galleries="activeGalleries" @select="routeToGallery"/>
          </div>
        </div>
      </div>
    </div>
  </CCol>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PTooltip from "@/domain/core/components/PTooltip.vue";
import {tooltipEventWizard} from "@/domain/eventWizard/components/overview/tooltip";
import GalleriesDropDown from "@/domain/eventWizard/components/overview/GalleriesDropDown.vue";

export default {
  name: "GalleriesUpload",
  components: {GalleriesDropDown, PTooltip},
  computed: {
    ...mapGetters('photoSearch', [
      'permissions'
    ]),
    ...mapGetters('event', [
      'picaServiceId',
    ]),
    ...mapGetters('eventGallery', [
      'galleries',
    ]),
    tab() {
      let route = this.$route.matched.find(m => m.props?.default?.tab)
      if (route) return route.props.default.tab
      return "detail"
    },
    tooltip() {
      return tooltipEventWizard.galleryUpload
    },
    activeGalleries() {
      return this.galleries.map(gallery => {
        const sub = gallery.sub.filter(sub => !sub.passive)
        if (sub.length === 0 && gallery.passive) return null
        return {
          ...gallery,
          sub: sub
        }
      }).filter(gallery => gallery !== null)
    }
  },
  async mounted() {
    if (!this.activeGalleries || this.activeGalleries.length === 0) return

    await this.setPicaServiceId({
      picaServiceId: this.picaServiceId,
      galleryId: this.galleries[0].id
    })
    try {
      await this.fetchConfig()
    } catch (e) {
      // User may not have permission to fetch config
    }
  },
  methods: {
    ...mapActions('photoSearch', [
      'fetchConfig',
      'setPicaServiceId'
    ]),
    routeToGallery(gallery) {
      this.$router.push({
        name: `eventWizard.gallery.${this.tab}`,
        params: {picaServiceId: this.picaServiceId, galleryId: gallery.id}
      })
    }
  }
}
</script>


<style scoped>

</style>